import { Pipe, PipeTransform } from '@angular/core';
import { DomSanitizer } from '@angular/platform-browser';

/**
 * Generated class for the LinkifyPipe pipe.
 *
 * See https://angular.io/docs/ts/latest/guide/pipes.html for more info on
 * Angular Pipes.
 */
@Pipe({
  name: 'linkify',
})
export class LinkifyPipe implements PipeTransform {

  constructor(private sanitizer: DomSanitizer) {

  }
  /**
   * Takes a value and makes it lowercase.
   */
  transform(value: string, ...args) {
    value = this.escapeHtml(value);
    return this.linkify(value);
  }

  private escapeHtml(str) {
    let entityMap = {
      "&": "&amp;",
      "<": "&lt;",
      ">": "&gt;",
      '"': '&quot;',
      "'": '&#39;'
    };

    return String(str).replace(/[&<>"']/g, function (s) {
        return entityMap[s];
    });
  }

  private linkify(plainText): string{
    let replacedText;
    // let replacePattern1;
    // let replacePattern2;

    // //URLs starting with http://, https://, or ftp://
    // replacePattern1 = /(\b(https?|ftp):(\/|&#x2F;)(\/|&#x2F;)[-A-Z0-9+&@#\/%?=~_|!:,.;]*[-A-Z0-9+&@#\/%=~_|])/gim;
    // // replacedText = plainText.replace(replacePattern1, '<a href="$1" target="_blank" style="cursor:pointer">$1</a>');
    // replacedText = plainText.replace(replacePattern1, '<a customhref="$1" tappable style="cursor:pointer">$1</a>');

    // //URLs starting with "www." (without // before it, or it'd re-link the ones done above).
    // replacePattern2 = /(^|[^\/])(www\.[\S]+(\b|$))/gim;
    // // replacedText = replacedText.replace(replacePattern2, '$1<a href="http://$2" target="_blank" style="cursor:pointer">$2</a>');
    // replacedText = replacedText.replace(replacePattern2, '$1<a customhref="http://$2" tappable style="cursor:pointer">$2</a>');

    let urlRegex = /((?:(http|https|Http|Https|rtsp|Rtsp):\/\/(?:(?:[a-zA-Z0-9\$\-\_\.\+\!\*\'\(\)\,\;\?\&\=]|(?:\%[a-fA-F0-9]{2})){1,64}(?:\:(?:[a-zA-Z0-9\$\-\_\.\+\!\*\'\(\)\,\;\?\&\=]|(?:\%[a-fA-F0-9]{2})){1,25})?\@)?)?((?:(?:[a-zA-Z0-9][a-zA-Z0-9\-]{0,64}\.)+(?:(?:aero|arpa|asia|a[cdefgilmnoqrstuwxz])|(?:biz|b[abdefghijmnorstvwyz])|(?:cat|com|coop|c[acdfghiklmnoruvxyz])|d[ejkmoz]|(?:edu|e[cegrstu])|f[ijkmor]|(?:gov|g[abdefghilmnpqrstuwy])|h[kmnrtu]|(?:info|int|i[delmnoqrst])|(?:jobs|j[emop])|k[eghimnrwyz]|l[abcikrstuvy]|(?:mil|mobi|museum|m[acdghklmnopqrstuvwxyz])|(?:name|net|n[acefgilopruz])|(?:org|om)|(?:pro|p[aefghklmnrstwy])|qa|r[eouw]|s[abcdeghijklmnortuvyz]|(?:tel|travel|t[cdfghjklmnoprtvwz])|u[agkmsyz]|v[aceginu]|w[fs]|y[etu]|z[amw]))|(?:(?:25[0-5]|2[0-4][0-9]|[0-1][0-9]{2}|[1-9][0-9]|[1-9])\.(?:25[0-5]|2[0-4][0-9]|[0-1][0-9]{2}|[1-9][0-9]|[1-9]|0)\.(?:25[0-5]|2[0-4][0-9]|[0-1][0-9]{2}|[1-9][0-9]|[1-9]|0)\.(?:25[0-5]|2[0-4][0-9]|[0-1][0-9]{2}|[1-9][0-9]|[0-9])))(?:\:\d{1,5})?)(\/(?:(?:[a-zA-Z0-9\;\/\?\:\@\&\=\#\~\-\.\+\!\*\'\(\)\,\_])|(?:\%[a-fA-F0-9]{2}))*)?(?:\b|$)/gi;
    replacedText = plainText.replace(urlRegex, function(url) {
      let href = url;
      if (url.toLowerCase().indexOf("http:") == -1 && url.toLowerCase().indexOf("https:") == -1) {
        href = "http://" + url;
      }
        return '<a customhref="' + href + '" tappable style="cursor:pointer">' + url + '</a>';
    });

    replacedText = replacedText.replace("59352957", "<a href='tel: 59352957'>59352957</a>");

    replacedText = this.sanitizer.bypassSecurityTrustHtml(replacedText)
    return replacedText;
  }
}



// WEBPACK FOOTER //
// ./src/pipes/linkify/linkify.ts